import { type AxiosError, isAxiosError } from 'axios';
import { type LogLevel } from './logger.types';

const extractApiStats = (axiosError: AxiosError) => ({
  request: {
    url: axiosError?.config?.url,
    baseURL: axiosError?.config?.baseURL,
    method: axiosError?.config?.method,
  },
  response: axiosError?.response?.status
    ? {
        status: axiosError?.response?.status,
        statusText: axiosError?.response?.statusText,
        data: axiosError?.response?.data,
        message: (axiosError?.response?.data as { message?: string })?.message,
      }
    : null,
});

/**
 * Formats an error for logging. If no error is provided, it will create one here to
 * ensure we have a stack trace.
 */
export const formatError = (
  level: LogLevel,
  message: string,
  error: unknown,
) => {
  if (isAxiosError(error)) {
    return {
      api: extractApiStats(error),
      error,
      message,
    };
  } else {
    let ensuredError = error;
    if (level === 'error' && !ensuredError) {
      ensuredError = new Error(message);
    }

    return {
      error: ensuredError,
      message,
    };
  }
};
